export function isActivityTypeId(item: string) {
    return item.endsWith('-activityTypes');
}

export function isNotActivityTypeId(item: string) {
    return !isActivityTypeId(item);
}
